import { Link } from "@tanstack/react-router";
import { useAuth } from "@/hooks/use-auth";
import { useLanguage } from "@/hooks/use-language";
import { Button } from "@/components/ui/button";
import { BrainCircuit } from "lucide-react";

export function NotFoundPage() {
  const { isAuthenticated } = useAuth();
  const { t } = useLanguage();

  return (
    <div className="flex min-h-svh flex-col items-center justify-center gap-6 bg-gradient-to-br from-blue-50 via-white to-purple-50 px-4 py-12 text-center dark:from-blue-950/40 dark:via-background dark:to-purple-950/40">
      <Link
        to="/"
        className="flex flex-col items-center gap-2 transition-opacity hover:opacity-90"
      >
        <div className="flex size-12 items-center justify-center rounded-xl bg-gradient-to-br from-blue-600 to-purple-600 text-white shadow-lg">
          <BrainCircuit className="size-6" />
        </div>
        <span className="text-xl font-bold tracking-tight">CBEET</span>
      </Link>

      <div className="flex flex-col items-center gap-2">
        <p className="text-6xl font-bold tracking-tight text-muted-foreground">
          404
        </p>
        <h1 className="text-xl font-semibold sm:text-2xl">
          {t("not_found.title")}
        </h1>
        <p className="max-w-md text-sm text-muted-foreground">
          {t("not_found.desc")}
        </p>
      </div>

      <div className="flex flex-col gap-2 sm:flex-row">
        <Link to="/">
          <Button variant="outline" className="cursor-pointer">
            {t("not_found.back_home")}
          </Button>
        </Link>
        {!isAuthenticated && (
          <Link to="/login">
            <Button className="cursor-pointer">
              {t("not_found.go_login")}
            </Button>
          </Link>
        )}
      </div>
    </div>
  );
}
